<app-table
  [data]="activityItems"
  [columns]="eventsColumns"
  [showSearch]="true"
  [searchLabel]="'COMMON.SEARCH' | translate"
  [searchPlacehoder]="'EMPLOYEE.CERTIFICATES.OVERVIEW.FIND-CERTIFICATES' | translate"
  [showActionButton]="showAddCertificateButton"
  actionButtonIcon="add"
  [actionButtonText]="'EMPLOYEE.CERTIFICATES.OVERVIEW.ADD-CERTIFICATE' | translate"
  (actionFunction)="showAddCerificatePopup()"
  [rowStyleCallback]="rowStyleCallback"
></app-table>

<dx-popup
  [height]="'auto'"
  [maxWidth]="830"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="externalCertificatePopupVisible"
  [title]="isEditMode ? ('EMPLOYEE.CERTIFICATES.TITLE-EDIT' | translate) : ('EMPLOYEE.CERTIFICATES.TITLE-ADD' | translate)"
  [dragEnabled]="false"
>
  <div *dxTemplate="let data of 'content'">
    @if(externalCertificatePopupVisible) {
      <app-add-external-certificate-dialog
        [editingPersonId]="editingPersonId"
        [isEditMode]="isEditMode"
        [isSuperAdmin]="isSuperAdmin"
        [isBroker]="isBroker"
        [isExternalCertificateApprovalEnabled]="isExternalCertificateApprovalEnabled"
        [certificate]="currentCertificate!"
        (onEventCreated)="onEventCreated()"
        (onEventRequested)="onEventRequested()"
      ></app-add-external-certificate-dialog>
    }
  </div>
</dx-popup>

<dx-popup
  [height]="'auto'"
  [maxWidth]="830"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="approvalRequestCertificatePopupVisible"
  [title]="('APPROVAL-REQUEST.EXTERNAL-CERTIFICATE-APPROVAL-REQUEST.TITLE-EDIT' | translate)"
  [dragEnabled]="false"
>
  <div *dxTemplate="let data of 'content'">
    @if(approvalRequestCertificatePopupVisible && currentExternalRequest) {
      <app-update-external-certificate-request-dialog
        [editingPersonId]="editingPersonId"
        [externalRequest]="currentExternalRequest"
        (onRequestUpdated)="onRequestUpdated()"
      ></app-update-external-certificate-request-dialog>
    }
  </div>
</dx-popup>

<dx-popup
  [height]="'auto'"
  [maxWidth]="830"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="reviewExternalCertificatePopupVisible"
  [title]="('APPROVAL-REQUEST.EXTERNAL-CERTIFICATE-APPROVAL-REQUEST.TITLE-REVIEW' | translate)"
  [dragEnabled]="false"
>
  <div *dxTemplate="let data of 'content'">
    @if(reviewExternalCertificatePopupVisible && currentExternalRequest) {
      <app-review-external-certificate-dialog
        [editingPersonId]="editingPersonId"
        [externalRequest]="currentExternalRequest"
        (onRequestReviewed)="onRequestReviewed()"
      ></app-review-external-certificate-dialog>
    }
  </div>
</dx-popup>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteTrainingModal"
  (submit)="deleteEvent()"
  [options]="trainingModalOptions"
></app-confirmation-dialog>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteApprovalRequestModal"
  (submit)="deleteApprovalRequestExternalCertificate()"
  [options]="approvalRequestModalOptions"
></app-confirmation-dialog>